import {
  DebuggerProvider,
  LoaderProvider,
  NavigationProvider,
  OttOverlayProvider,
  OverlayProvider,
  PageViewProvider,
} from '../../contexts'
import { ICategoryTreeItem, Ileafs, IProgramData } from '../../types'
import React from 'react'
import { IOttPageMeta } from '../../utils'
import { PageViewInDayProvider } from '../../contexts/hooks/usePageViewInDay'
import { OttPlayerProvider } from '../contexts/providers/OttPlayerProvider'
import { UserActivityProvider } from '../../contexts/UserActivityContext'
import { TaboolaProvider } from '../../components/Taboola/useTaboola'
import { GoogleAdsProvider } from '../../contexts/providers/GoogleAdsProvider/GoogleAdsContext'
import { ExternalPathsProvider, useAdBlockDetect } from '../../contexts'
import { ILazyLoadConfig } from '../../sharedComponents/types'

type OttProps = {
  children: React.ReactNode
  theTree: ICategoryTreeItem[]
  leafs: Ileafs[]
  program: IProgramData | null
  assetMeta: IOttPageMeta
  logo?: string
  page_type?: string
  isEmbed?: boolean
  googleAdsConfig?:
    | {
        enableSingleRequest?: boolean
        enableLazyLoad?: boolean
        lazyLoadConfig?: ILazyLoadConfig
      }
    | undefined
}

export const OttProviders = ({
  children,
  theTree,
  leafs,
  program,
  assetMeta,
  logo,
  page_type,
  googleAdsConfig,
  isEmbed,
}: OttProps) => {
  // AdBlock detection - re-runs on every page entry (incl. SPA)
  useAdBlockDetect()

  return (
    <NavigationProvider>
      <UserActivityProvider>
        <DebuggerProvider>
          <PageViewProvider>
            <PageViewInDayProvider>
              <LoaderProvider>
                <OttOverlayProvider
                  theTree={theTree}
                  leafs={leafs}
                  program={program}
                  assetMeta={assetMeta}
                  logo={logo}
                  page_type={page_type}
                >
                  <OverlayProvider>
                    <OttPlayerProvider isEmbed={!!isEmbed}>
                      <TaboolaProvider>
                        <GoogleAdsProvider config={googleAdsConfig}>
                          <ExternalPathsProvider>
                            {children}
                          </ExternalPathsProvider>
                        </GoogleAdsProvider>
                      </TaboolaProvider>
                    </OttPlayerProvider>
                  </OverlayProvider>
                </OttOverlayProvider>
              </LoaderProvider>
            </PageViewInDayProvider>
          </PageViewProvider>
        </DebuggerProvider>
      </UserActivityProvider>
    </NavigationProvider>
  )
}
